import React from 'react';
import { Form } from '@leverege/ui-elements';
import { ApiProvider } from '@leverege/api-redux';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withContexts(Component) {
  return props => /*#__PURE__*/_jsx(Form.Context.Consumer, {
    children: form => /*#__PURE__*/_jsx(ApiProvider.Context.Consumer, {
      children: api => /*#__PURE__*/_jsx(Component, {
        form: form,
        api: api,
        ...props
      })
    })
  });
}